import { Pipe, PipeTransform } from "@angular/core";
import { UserDataModel } from "src/app/settings-interfaces/users.models";
import { UtilsService } from "src/app/shared";
@Pipe({
    name: "UserInitial",
})
export class UserInitialPipe implements PipeTransform {
    transform(assignedUser: UserDataModel | null, DefaultValue: string): string {
        if (!assignedUser || UtilsService.isNullOrWhitespace(assignedUser.FirstName) || UtilsService.isNullOrWhitespace(assignedUser.LastName)) {
            return DefaultValue;
        }
        return assignedUser.FirstName[0] + assignedUser.LastName[0];
    }
}
